import { Accordion } from "@chakra-ui/react";
import { Card } from "../../../../../components/Card";
import SustainableFinanceRegulationsAccordionItem from "./SustainableFinanceRegulationsAccordionItem";

function SustainableFinanceRegulationsInfo() {
  const extendedJsonTitles = [
    "summary", "guidelines", "reporting", "disclosures", "taxonomies",
    "commitment", "carbonPricing", "financialPolicy", "tax", "framework"
  ];

  return <Card>
    <Accordion defaultIndex={[0]} allowToggle>
      {extendedJsonTitles.map(title => {
          return <SustainableFinanceRegulationsAccordionItem key={`regulations-info-${title}`} title={title} />;
        }
      )}
    </Accordion>
  </Card>;
}

export default SustainableFinanceRegulationsInfo;